<template>
  <div class = "container" id="table">
    <v-tooltip bottom dark color="#333">
      <template v-slot:activator="{ on }">
        <div class="back">
          <button v-on="on" class="soup-btn" @click="backToSoup">
            <v-icon large>mdi-arrow-left-circle</v-icon>
          </button>
        </div>
      </template>
      <span class="tooltip-text">Back</span>
      <span class="key">
        <span class="key-inner">esc</span>
      </span>
    </v-tooltip>
    <v-data-table
      :headers="storeState.details.tableHeaders"
      :items="storeState.details.table"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>{{storeState.details.model}} ({{storeState.details.email}})</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider>
          <div class="flex-grow-1"></div>
        </v-toolbar>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
        >
          edit
        </v-icon>
        <v-icon
          small
          @click="deleteItem(item)"
        >
          delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        No results
      </template>
    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';
import InputTag from 'vue-input-tag'
import Comment from './Comment'
import { store } from '../store.js';
Vue.component('input-tag', InputTag);
Vue.component('comment-div', Comment);

document.body.setAttribute('data-app', true)

export default {
  mounted() {
    window.bus.$on('detailsUpdated',(details) => {
      console.log('detailsUpdated.....', details)
      this.$forceUpdate()
      // Do stuff
    });
  },
  data() {
    return {
      storeState: store.state,
      store: store,
      editableDetails: store.state.editableDetails,
      tagRules: [
        v => false
      ],
      tagInput: '',
      editingTag: false,
      editingComment: false,
      commentTitle: 'Mike ' + this.getFromNow(1568851200000),
      chip1: true,
      editedItem: {},
      dialog: false,
      
      searchIndex: 0,
      searchTerm: '',
      newTag: '',
      searchIn: [],
      searchResults: [],
      consumedOn: new Date().toISOString().substr(0, 10),
      consumedOnCal: false,
      addingFood: false,
      removingFood: false,
      expanded: [],
      checked: [],
      amount: '',
      userEntries: [],
      userEntriesHeader: [], 
      loadingUserData: false,
      loading: true,
      selectedFood: false,
      unit: 'g',
      headers: [],
      foodFacts: [],
      amountRules: [
        value => !!value || 'Required.',
        value => !isNaN(value) || 'Enter a number'
      ],
    };
  },
  filters: {
    dateFilter: function (date) {
      console.log(date)
      date = date.fromNow()
      return date
      // return moment(date).fromNow();
    }
  },
  components: {
  },
  watch: {
    'editableDetails.tags': {
        handler: function (val, oldVal) {
            console.log('watch 1', 'newval: ', val, '   oldVal:', oldVal)
            store.updateEditableDetails(this.storeState.details.email, 'users', this.storeState.editableDetails)
        },
        deep: true
    },
    'storeState.block.title': {
        handler: function (val, oldVal) {
          store.updateBlock({gotBlock: this.storeState.gotBlock})
          if (this.storeState.block.title && this.storeState.block.title.length > 0) {
            document.title = this.storeState.block.title;
          }
        },
        deep: false
    },
    'editableDetails.reminder': {
        handler: function (val, oldVal) {
            console.log('watch 1', 'newval: ', val, '   oldVal:', oldVal)
            store.updateEditableDetails(this.storeState.details.email, 'users', this.storeState.editableDetails)
        },
        deep: true
    },
    'storeState.details.table': {
        handler: function (val, oldVal) {
            console.log('watch 1', 'newval: ', val, '   oldVal:', oldVal)
            store.updateEditableDetails(this.storeState.details.email, 'users', this.storeState.editableDetails)
        },
        deep: true
    }
  },
  methods: {
    createTag(tag) {
      console.log(tag)
      this.storeState.cmdkParentCmd = 'createTag'
      this.$parent.openCmdK({cmdkParentCmd: 'createTag', cmdkInput: tag})
    },
    backToSoup() {
      this.$router.go(-1);
    },
    tagAddedEnter() {
      console.log('this.tagInput: ', this.tagInput, this.editableDetails.tags)
      this.editableDetails.tags = this.editableDetails.tags.filter(el => el && el.text && el.text.length > 0)
      // for (let i = 0; i < this.tags.length; i++) {
      //   let el = this.tags[i];
      //   if (el && el.text && el.text.length > 0)
      // }
      this.tagInput = ''
    },
    editTag(index, item) {
      if (!this.editing) {
        this.editing = item
        this.index = index
      } else {
        this.editing = null
        this.index = -1
      }
    },
    addReminder(e) {
      this.storeState.cmdkParentCmd = 'addReminder'
      this.$parent.openCmdK({cmdkParentCmd: 'addReminder', cmdkInput: ''})
      console.log('cmdk: ', e)
    },
    removeTag(item) {
      this.storeState.editableDetails.tags.splice(this.storeState.editableDetails.tags.indexOf(item), 1)
      this.storeState.editableDetails.tags = [...this.storeState.editableDetails.tags]
    },
    selectTag(item) {

    },
    getFromNowDt(date) {
      console.log(date)
      return moment(date).fromNow();
    },
    pastDue(date) {
      let red = moment(date).isSameOrBefore(moment())
      if (date) return {red: red, color: red ? '#eb5757' : '#2eaadc'};
      return {red: false, color: '#000000de'}
    },
    joinedOn(date) {
      return moment(Number(date)).format('MMMM Do YYYY')
    },
    getFromNow(date) {
      return moment(Number(date)).fromNow();
    },
    closeEdit(d) {
      console.log('closeEdit: ', d)
    },
    saveEdit(d) {
      console.log('saveEdit: ', d)
    },
    moment: function () {
      return moment();
    },
    validateSearch(val) {
      console.log('val term: ', val)
      this.searchTerm = this.newTag
      if (val.startsWith('#')) return true
      return false
    },
    getTags() {
      console.log('val term: ', this.newTag)
    },
    search(e) {
      console.log('search term: ', this.searchTerm, e)
      if (e.keyCode === 13) { //enter
        console.log('hit enter...')
        return
      }
      var self = this
      // window.db.users.where('email').startsWithIgnoreCase(this.searchTerm).toArray(function(result) {
      //   console.log("Found: " + result.length);
      //   self.searchResults = result.slice(0, 20)
      // });
      // db.users.filter (function (user) { return user.email.includes(self.searchTerm) })
      //   .toArray()
      //   .then(function(result) {
      //     console.log(result)
      //     self.searchResults = result.slice(0, 20)
      //   });
      // debugger
      // this.searchResults = this.storeState.dataModel.users.filter(o => o.email.includes(this.searchTerm)).slice(0, 20)
      // this.searchResults = this.storeState.dataModel.users.filter(o => o.email.startsWith(this.searchTerm)).slice(0, 20)
      // debugger
      // this.searchResults = this.storeState.dataModel.users.filter(o => o.email.includes(this.searchTerm)).slice(0, 20)
      function successHandler(tx, results) {
        var arr = []
        console.log('found: ', results.rows.length)
        for (let i = 0; i < results.rows.length; i++) {
          let row = results.rows.item([i]);
          arr.push(row)
        }
        self.searchResults = arr
      }
      function errorHandler(transaction, error) {
        console.log(`Error : ${error.message}`);
      }
      function execSql(db, sql, q, successHandler) {
        db.transaction(function (tx) { 
            tx.executeSql(sql, [], successHandler, errorHandler); 
        })
      }
      // execSql(this.storeState.db, `SELECT * FROM users WHERE users MATCH '${this.searchTerm}' LIMIT 20`, '', successHandler)
      let sql = `SELECT * FROM users WHERE LOWER(email) LIKE '%${this.searchTerm}%' LIMIT 20`
      // debugger
      execSql(this.storeState.db, sql, '', successHandler)
      
    },
    getPath(path) {
      if (window.location.hostname === 'localhost') {
        return `http://localhost:5000${path}`
      }
      return  `https://seekwell.io${path}`
    },
  },
  created() {
  },
};
</script>

<style>
.active {
  background-color: #eee;
}
.vue-input-tag-wrapper {
    background-color: #fff;
    border: none;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}

.vue-input-tag-wrapper .new-tag {
    background: transparent;
    border: none;
    color: #333;
    flex-grow: 1;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 6px;
    margin-top: 1px;
    outline: none;
    padding: 0px;
}

.vue-input-tag-wrapper .input-tag {
    background-color: #eee;
    border: 1px solid #eee;
    border-radius: 2px;
    outline: none;
    color: #333;
    display: inline-block;
    font-size: 13px;
    font-weight: 400;
    margin-bottom: 4px;
    margin-right: 4px;
    padding: 3px;
}
.searchResults {
  margin-top: 20px;
  margin-left: 2px;
}
.searchInput {
  height: 38px;
  font-size: 20px;
  outline: none;
  width: 100%;
}
.container {
  padding-top: 30px;
  padding-left: 25px;
  padding-right: 20px;
}
.dateContainer {
  width: 180px;
  padding-top: 30px;
}
.amount {
  width: 180px;
  /* width: 100%; */
}
.padded {
  padding: 20px;
}
.btn-pad {
  margin: 20px;
}
.sub-title {
  font-size: 16px;
  padding-top: 0px;
}
.timeline-container {
  padding-top: 30px;
  padding-bottom: 10px;
}
.details-card {
  padding-left: 30px;
  padding-right: 30px;
}
.tag {
  margin-left: 0px;
}
.tag2 {
  margin-left: 15px;
}
.comment-text {
  color: rgba(0, 0, 0, 0.87);
}
.comment-title {
  font-size: 14px;
  font-weight: 700;
}
.comment-time {
  font-size: 12px;
  color: rgba(55, 53, 47, 0.4);
  font-weight: normal;
}
.card-head {
  font-size: 24px;
  font-weight: 700;
}
.reminder {
  color: rgb(46, 170, 220);
  cursor: pointer;
}
.clock {
  margin-bottom: 2px;
}
.reminder-text {
  margin-left: 5px;
}
.create-tag {
  margin-left: 15px;
}
</style>
